<template>
  <section class="alunos" :class="{ mostrar: storeEditar.mostrarAlunos }">
    <div class="opcoes">
      <div class="topo">
        <h3>{{ storeAlunos.alunos?.length }} Alunos</h3>
        <div class="campo">
          <Svgs nome="lupa" />
          <input type="text" spellcheck="false" placeholder="Buscar aluno" v-model="termoBusca" />
        </div>
        <button @click="novoAluno()">
          <Svgs nome="mais" />
          <span>Aluno</span>
        </button>
      </div>
      <div class="lista">
        <button v-for="(aluno, index) in alunosFiltrados" :key="index" :class="{ ativo: storeAlunos.aluno?._id === aluno._id }" @click="receberAluno(aluno._id)">
          <div class="foto" :style="`background-image: url('${aluno.imagemPerfil}')`"></div>
          <div class="texto">
            <h3>{{ aluno.nome }}</h3>
            <p>{{ aluno.email }}</p>
          </div>
        </button>
      </div>
    </div>
    <div class="conteudo">
      <div class="parte" v-if="!storeAlunos.aluno">
        <div class="vazio">
          <Svgs nome="levelmember-icone" />
          <h3>Seleciona um aluno</h3>
          <p>Escolha um aluno na lista lateral para ver os dados e ações</p>
        </div>
      </div>
      <!-- Informações -->
      <div class="parte" v-else>
        <div class="carregando" :class="{ mostrar: state.loading }">
          <span></span>
        </div>
        <div class="titulo">
          <div class="foto" :style="`background-image: url('${storeAlunos.aluno?.imagemPerfil}')`"></div>
          <div class="nome">
            <h3>{{ storeAlunos.aluno?.nome }}</h3>
            <p>{{ storeAlunos.aluno?.email }}</p>
          </div>
          <div class="resetar">
            <button class="abrir" @click="resetar = !resetar" :class="{ ativo: resetar }">
              <Svgs nome="cadeado" />
              <span>Resetar Senha</span>
            </button>
            <div class="confirmar" :class="{ mostrar: resetar }">
              <p>Deseja resetar senha para 123456789?</p>
              <button @click="resetarSenha()">Sim</button>
              <button @click="resetar = !resetar">Não</button>
            </div>
          </div>
        </div>
        <div class="dados">
          <div class="linha">
            <Svgs nome="whatsapp" />
            <h3>Whatsapp</h3>
            <p>{{ storeAlunos.aluno?.contato?.whatsapp }}</p>
          </div>
          <div class="linha">
            <Svgs nome="dinheiro" />
            <h3>Pontos</h3>
            <p>{{ storeAlunos.aluno?.pontos }}</p>
          </div>
          <div class="linha">
            <Svgs nome="sair" />
            <h3>Último acesso</h3>
            <p>{{ formatarData(storeAlunos.aluno?.dataUltimoAcesso) }}</p>
          </div>
          <div class="linha">
            <Svgs nome="relogio" />
            <h3>Registro</h3>
            <p>{{ formatarData(storeAlunos.aluno?.dataRegistro) }}</p>
          </div>
        </div>

        <div class="dados" v-if="storeCursos.cursos?.length > 0">
          <h2>Cursos do aluno</h2>
          <div class="linha" v-for="curso in cursosMesclados" :key="curso._id">
            <div class="nome">
              <h3>{{ curso.nome }}</h3>
              <div class="info" v-if="curso.acessoLiberado">
                <Svgs nome="curso" />
                <p>Acesso até {{ formatarDataSimples(curso.dataVencimento) }}</p>
              </div>
              <div class="info bloqueado" v-if="!curso.acessoLiberado">
                <Svgs nome="cadeado" />
                <p>Acesso Bloqueado</p>
              </div>
            </div>
            <button class="editar" @click="abrirLiberarAcesso(curso._id)">
              <Svgs nome="editar" />
            </button>
            <button class="sair" @click="abrirBloquearAcesso(curso._id)" v-if="curso.acessoLiberado">
              <Svgs nome="sair" />
            </button>
            <div class="bloquear" :class="{ mostrar: state.bloquearAcesso && state.cursoId === curso._id }">
              <h3>Bloquear acesso?</h3>
              <button class="sim" @click="bloquearAcesso(curso._id)">Sim</button>
              <button class="nao" @click="state.bloquearAcesso = false">Não</button>
            </div>
            <div class="liberar" :class="{ mostrar: state.liberarAcesso && state.cursoId === curso._id }">
              <div class="info">
                <h3>Liberar Acesso até</h3>
                <input v-model="state.dataAcesso" type="tel" spellcheck="false" placeholder="00/00/0000" v-mask="`##/##/####`" />
              </div>
              <div class="botoes">
                <button class="sim" @click="liberarAcesso(curso._id)">Confirmar</button>
                <button class="nao" @click="state.liberarAcesso = false">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, onMounted, reactive, inject, ref, watch } from 'vue'
import { useStoreEditar, useStoreAlunos, useStoreCursos, useStoreAreas, useStoreModal } from '@stores'
import Svgs from '@svgs'

const storeAreas = useStoreAreas()
const storeEditar = useStoreEditar()
const storeAlunos = useStoreAlunos()
const storeCursos = useStoreCursos()
const storeModal = useStoreModal()
const emitter = inject('emitter')

const termoBusca = ref('')
const resetar = ref(false)

const state = reactive({
  confirmacao: false,
  bloquearAcesso: false,
  liberarAcesso: false,
  dataAcesso: '',
  cursoId: null,
  loading: false
})

const alunosFiltrados = computed(() => {
  let alunos = storeAlunos.alunos

  if (termoBusca.value) {
    const query = termoBusca.value.toLowerCase()
    alunos = alunos.filter((aluno) => aluno.nome.toLowerCase().includes(query) || aluno.email.toLowerCase().includes(query))
  }

  return alunos
})

const cursosMesclados = computed(() => {
  if (!storeCursos.cursos) {
    return []
  }
  const cursosCompradosMap = new Map(storeAlunos.aluno?.cursosComprados.map((curso) => [curso.idCurso._id, curso]))
  return storeCursos.cursos.map((curso) => {
    const cursoComprado = cursosCompradosMap.get(curso._id)
    if (cursoComprado) {
      return {
        ...curso,
        acessoLiberado: true,
        dataVencimento: cursoComprado.dataVencimento
      }
    } else {
      return {
        ...curso,
        acessoLiberado: false
      }
    }
  })
})

function novoAluno() {
  storeModal.abrirModal('criarAluno', 'mais', 'Criar aluno')
}

function formatarData(data) {
  const agora = new Date()
  const dataNotificacao = new Date(data)
  const diferencaMs = agora - dataNotificacao
  const diferencaMinutos = Math.floor(diferencaMs / 60000)
  const diferencaHoras = Math.floor(diferencaMs / 3600000)

  if (diferencaMinutos < 1) {
    return 'há segundos'
  } else if (diferencaMinutos < 60) {
    return `há ${diferencaMinutos} minuto${diferencaMinutos > 1 ? 's' : ''}`
  } else if (diferencaHoras < 24) {
    return `há ${diferencaHoras} hora${diferencaHoras > 1 ? 's' : ''}`
  } else {
    const day = String(dataNotificacao.getDate()).padStart(2, '0')
    const month = String(dataNotificacao.getMonth() + 1).padStart(2, '0')
    const year = dataNotificacao.getFullYear()
    const hours = String(dataNotificacao.getHours()).padStart(2, '0')
    const minutes = String(dataNotificacao.getMinutes()).padStart(2, '0')

    return `${day}/${month}/${year} às ${hours}h${minutes}`
  }
}

function formatarDataSimples(data) {
  const dataSetada = new Date(data)

  const day = String(dataSetada.getDate()).padStart(2, '0')
  const month = String(dataSetada.getMonth() + 1).padStart(2, '0')
  const year = dataSetada.getFullYear()

  return `${day}/${month}/${year}`
}

async function resetarSenha() {
  const idArea = storeAreas.area?._id
  const idAluno = storeAlunos.aluno._id
  const delecaoOk = await storeAlunos.resetarSenha(idArea, idAluno)
  if (delecaoOk !== true) return

  resetar.value = false
  emitter.emit('mostrarAlerta', { tipo: 'positivo', mensagem: 'Senha resetada para 123456789' })
  emitter.emit('atualizarAluno')
}

async function liberarAcesso(idCurso) {
  const idArea = storeAreas.area?._id
  const idAluno = storeAlunos.aluno._id

  let [dia, mes, ano] = state.dataAcesso.split('/')
  let dataAcesso = new Date(`${ano}-${mes}-${dia}T00:00:00`)

  const hoje = new Date()
  hoje.setHours(0, 0, 0, 0)

  if (dataAcesso < hoje) {
    dataAcesso = hoje
  }

  dataAcesso.setDate(dataAcesso.getDate() + 1)
  dataAcesso.setHours(0, 0, 0, 0)

  const payload = {
    ativo: true,
    dataVencimento: dataAcesso.toISOString()
  }

  const resultado = await storeAlunos.alterarAcesso(idArea, idAluno, idCurso, payload)
  if (resultado) {
    state.liberarAcesso = false
    emitter.emit('mostrarAlerta', { tipo: 'positivo', mensagem: 'Curso liberado com sucesso' })
    emitter.emit('atualizarAluno')
  }
}

async function bloquearAcesso(idCurso) {
  const idArea = storeAreas.area?._id
  const idAluno = storeAlunos.aluno._id

  const ontem = new Date()
  ontem.setDate(ontem.getDate() - 1)
  ontem.setHours(0, 0, 0, 0)

  const payload = {
    ativo: false,
    dataVencimento: ontem.toISOString()
  }

  const resultado = await storeAlunos.alterarAcesso(idArea, idAluno, idCurso, payload)
  if (resultado) {
    state.bloquearAcesso = false
    emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: 'Curso bloqueado com sucesso' })
    emitter.emit('atualizarAluno')
  }
}

function abrirLiberarAcesso(idCurso) {
  state.cursoId = idCurso
  state.liberarAcesso = true
}

function abrirBloquearAcesso(idCurso) {
  state.cursoId = idCurso
  state.bloquearAcesso = true
}

async function receberAlunos() {
  state.loading = true
  const idArea = storeAreas.area?._id
  await storeAlunos.receberTodos(idArea)
  state.loading = false
}

async function receberAluno(idAluno) {
  state.loading = true
  const idArea = storeAreas.area?._id
  await storeAlunos.receberPorId(idArea, idAluno)
  state.loading = false
}

async function receberAlunoAtual() {
  state.loading = true
  const idArea = storeAreas.area?._id
  const idAluno = storeAlunos.aluno._id
  await storeAlunos.receberPorId(idArea, idAluno)
  state.loading = false
}

function receberDataHoje() {
  const hoje = new Date()
  const dia = String(hoje.getDate()).padStart(2, '0')
  const mes = String(hoje.getMonth() + 1).padStart(2, '0')
  const ano = hoje.getFullYear()

  state.dataAcesso = `${dia}/${mes}/${ano}`
}

watch(
  () => storeAreas.area?._id,
  (idArea) => {
    if (idArea) {
      receberAlunos()
    }
  },
  { immediate: true }
)

onMounted(() => {
  receberDataHoje()
  emitter.on('atualizarAlunos', receberAlunos)
  emitter.on('atualizarAluno', receberAlunoAtual)
})
</script>

<style scoped>
section.alunos {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  position: fixed;
  top: -100dvh;
  left: 0;
  width: 100%;
  height: calc(100dvh - 50px);
  background-color: var(--cor-escuro-1);
  overflow-y: scroll;
  scrollbar-width: none;
  z-index: 5;
  transition: all 0.8s;
}
section.alunos::-webkit-scrollbar {
  display: none;
}
section.alunos.mostrar {
  top: 60px;
}
section.alunos.mostrar .opcoes {
  left: 0;
}
.opcoes {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: fixed;
  background-color: var(--cor-escuro-2);
  border-right: 2px solid var(--cor-escuro-3);
  top: 50px;
  left: -320px;
  width: 320px;
  height: 100%;
  transition: all 0.5s;
}
.opcoes .lista {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 15px 15px 80px 15px;
  overflow-y: scroll;
  height: 100%;
  width: 100%;
  scrollbar-width: none;
}
.opcoes .lista::-webkit-scrollbar {
  display: none;
}
.opcoes .topo {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: 15px;
  width: 100%;
  border-bottom: 1px solid var(--cor-escuro-3);
}
.opcoes .topo .campo {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: calc(100% - 100px);
}
.opcoes .topo .campo svg {
  position: absolute;
  left: 15px;
  width: 12px;
  min-width: 12px;
  fill: var(--cor-escuro-6);
}
.opcoes .topo .campo input {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: var(--cor-escuro-3);
  width: 100%;
  border-radius: 10px;
  padding: 0 10px 0 35px;
  height: 40px;
  transition: all 0.3s;
}
.opcoes .topo .campo input:focus {
  background-color: var(--cor-escuro-4);
}
.opcoes .topo .campo input::placeholder {
  color: var(--cor-escuro-6);
}
.opcoes .topo h3 {
  font-family: var(--medium);
  font-size: var(--f1);
  color: var(--cor-branco);
  margin: 0 0 10px 0;
  width: 100%;
}
.opcoes .topo button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--cor-marca);
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-branco-fixo);
  border-radius: 10px;
  width: 90px;
  height: 40px;
  margin: 0 0 0 10px;
  transition: all 0.3s;
}
.opcoes .topo button svg {
  width: 10px;
  min-width: 10px;
  fill: var(--cor-branco-fixo);
  margin: 0 10px 0 0;
}
.opcoes .topo button:hover {
  background-color: var(--cor-marca-escuro);
}
.opcoes .lista button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 15px 12px;
  background-color: var(--cor-escuro-3);
  border: 2px solid var(--cor-escuro-3);
  border-radius: 8px;
  margin: 5px 0 0 0;
  transition: all 0.3s;
}
.opcoes .lista button:hover {
  background-color: var(--cor-escuro-2);
}
.opcoes .lista button.ativo {
  border: 2px solid var(--cor-marca);
  pointer-events: none;
}
.opcoes .lista button .texto {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.opcoes .lista button .texto h3 {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-branco);
  margin: 0 0 5px 0;
}
.opcoes .lista button .texto p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
}
.opcoes .lista button .foto {
  width: 25px;
  min-width: 25px;
  height: 25px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  background-color: var(--cor-escuro-4);
  margin: 0 10px 0 0;
}
.conteudo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: calc(100% - 320px);
  padding: 30px;
}
.conteudo .parte {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 600px;
  border: 2px solid var(--cor-escuro-3);
  padding: 30px;
  border-radius: 8px;
  position: relative;
  animation: fadeIn 0.3s linear;
}
.conteudo .parte .carregando {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: var(--cor-escuro-1);
  border-radius: 10px;
  z-index: 3;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s;
}
.conteudo .parte .carregando.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.conteudo .parte .carregando span {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 3px solid var(--cor-marca);
  border-top: 3px solid transparent;
  animation: girando 1s linear infinite;
}
.conteudo .parte .vazio {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  padding: 80px 0;
}
.conteudo .parte .vazio svg {
  width: 100px;
  min-width: 100px;
}
.conteudo .parte .vazio h3 {
  font-family: var(--bold);
  font-size: var(--f3);
  color: var(--cor-branco);
  margin: 40px 0 10px 0;
}
.conteudo .parte .vazio p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  line-height: 1.5;
  width: 100%;
  max-width: 400px;
}
.conteudo .parte .titulo {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 0 15px 0;
}
.conteudo .parte .titulo .foto {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: var(--cor-escuro-3);
  margin: 0 10px 0 0;
  background-size: cover;
  background-position: center;
}
.conteudo .parte .titulo .nome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.conteudo .parte .titulo .nome h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.conteudo .parte .titulo .nome p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  margin: 5px 0 0 0;
}
.conteudo .parte .titulo .resetar {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-left: auto;
}
.conteudo .parte .titulo .resetar button.abrir {
  display: flex;
  align-items: center;
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: var(--cor-escuro-3);
  padding: 10px 15px;
  border-radius: 10px;
  transition: all 0.3s;
}
.conteudo .parte .titulo .resetar button.abrir:hover {
  background-color: var(--cor-escuro-4);
}
.conteudo .parte .titulo .resetar button.abrir.ativo {
  background-color: var(--cor-escuro-4);
}
.conteudo .parte .titulo .resetar button.abrir svg {
  width: 12px;
  min-width: 12px;
  fill: var(--cor-branco);
  margin: 0 10px 0 0;
}
.conteudo .parte .titulo .resetar .confirmar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 45px;
  right: 0;
  padding: 15px;
  background-color: var(--cor-escuro-2);
  border: 1px solid var(--cor-escuro-4);
  border-radius: 10px;
  z-index: 2;
  width: 160px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all 0.3s;
}
.conteudo .parte .titulo .resetar .confirmar.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.conteudo .parte .titulo .resetar .confirmar p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  text-align: center;
  line-height: 1.5;
  margin: 0 0 5px 0;
}
.conteudo .parte .titulo .resetar .confirmar button {
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: transparent;
  padding: 5px 10px;
  border-radius: 5px;
  transition: all 0.3s;
}
.conteudo .parte .titulo .resetar .confirmar button:hover {
  opacity: 0.6;
}
.conteudo .parte .titulo .resetar .confirmar button:nth-child(2) {
  color: var(--cor-vermelho);
}
.conteudo .parte .cursos {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-bottom: 1px solid var(--cor-escuro-3);
  margin: 20px 0 0 0;
}
.conteudo .parte .dados {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-bottom: 1px solid var(--cor-escuro-3);
  margin: 20px 0 0 0;
}
.conteudo .parte .dados h2 {
  font-family: var(--bold);
  font-size: var(--f3);
  color: var(--cor-branco);
  margin: 10px 0 20px 0;
  width: 100%;
}
.conteudo .parte .linha {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 15px;
  border-radius: 10px;
  background-color: var(--cor-escuro-2);
  margin: 0 0 10px 0;
  position: relative;
}
.conteudo .parte .linha h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.conteudo .parte .linha p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-marca);
  margin-left: auto;
}
.conteudo .parte .linha svg {
  width: 15px;
  min-width: 15px;
  max-height: 15px;
  fill: var(--cor-branco);
  margin: 0 10px 0 0;
}
.conteudo .parte .linha button.editar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 10px;
  background-color: var(--cor-escuro-3);
  margin-left: auto;
  transition: all 0.3s;
}
.conteudo .parte .linha button.editar:hover {
  background-color: var(--cor-escuro-4);
}
.conteudo .parte .linha button.editar svg {
  fill: var(--cor-branco);
  margin: 0;
}
.conteudo .parte .linha button.sair svg {
  fill: var(--cor-branco-fixo);
  margin: 0;
}
.conteudo .parte .linha button.sair {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 10px;
  background-color: var(--cor-vermelho);
  margin: 0 0 0 10px;
  transition: all 0.3s;
}
.conteudo .parte .linha button.sair:hover {
  background-color: var(--cor-vermelho-escuro);
}
.conteudo .parte .linha .nome {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.conteudo .parte .linha .nome .info {
  display: flex;
  align-items: center;
  padding: 10px 0 0 0;
}
.conteudo .parte .linha .nome .info.bloqueado svg {
  fill: var(--cor-vermelho);
}
.conteudo .parte .linha .nome .info.bloqueado p {
  color: var(--cor-vermelho);
}
.conteudo .parte .linha .nome .info svg {
  fill: var(--cor-verde);
}
.conteudo .parte .linha .nome .info p {
  color: var(--cor-verde);
}
.conteudo .parte .linha .bloquear {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  position: absolute;
  height: 100%;
  width: 100%;
  max-width: 150px;
  top: 0;
  right: 0;
  padding: 10px 10px 10px 20px;
  background-color: var(--cor-escuro-2);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 2;
  transition: all 0.3s;
}
.conteudo .parte .linha .bloquear.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.conteudo .parte .linha .bloquear h3 {
  width: 100%;
  margin: 0;
  padding: 0;
  text-align: right;
}
.conteudo .parte .linha .bloquear button.sim {
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-vermelho);
  background-color: transparent;
  padding: 0 5px;
  margin: 0 5px 0 10px;
  transition: all 0.3s;
}
.conteudo .parte .linha .bloquear button.nao {
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: transparent;
  padding: 0 5px;
  transition: all 0.3s;
}
.conteudo .parte .linha .bloquear button:hover {
  opacity: 0.6;
}
.conteudo .parte .linha .liberar {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
  background-color: var(--cor-escuro-2);
  padding: 5px 10px 5px 20px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 2;
  transition: all 0.3s;
}
.conteudo .parte .linha .liberar.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.conteudo .parte .linha .liberar .info {
  display: flex;
  align-items: center;
}
.conteudo .parte .linha .liberar .botoes {
  display: flex;
  align-items: center;
  margin: 5px 0 0 0;
}
.conteudo .parte .linha .liberar h3 {
  margin: 0 5px 0 0;
}
.conteudo .parte .linha .liberar input {
  text-align: center;
  align-items: center;
  justify-content: center;
  padding: 5px;
  width: 100px;
  border-radius: 5px;
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
  background-color: var(--cor-escuro-3);
  border: none;
}
.conteudo .parte .linha .liberar input:focus {
  background-color: var(--cor-escuro-4);
}
.conteudo .parte .linha .liberar button.sim {
  font-family: var(--bold);
  font-size: var(--f1);
  color: var(--cor-verde);
  background-color: transparent;
  padding: 5px;
  margin: 0 10px 0 20px;
  transition: all 0.3s;
}
.conteudo .parte .linha .liberar button.nao {
  font-family: var(--bold);
  font-size: var(--f1);
  color: var(--cor-branco);
  background-color: transparent;
  padding: 5px;
  transition: all 0.3s;
}
.conteudo .parte .linha .liberar button:hover {
  opacity: 0.6;
}
/* Responsivo */
@media screen and (max-width: 1000px) {
  .opcoes {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    position: fixed;
    overflow-y: scroll;
    top: -60px;
    left: 0;
    width: 100%;
    height: 60px;
    max-height: 60px;
    border-right: none;
    padding: 0 15px;
    border-bottom: 2px solid var(--cor-escuro-3);
    scrollbar-width: none;
    z-index: 2;
  }
  section.configurar.mostrar .opcoes {
    top: 60px;
  }
  .opcoes::-webkit-scrollbar {
    display: none;
  }
  .opcoes h3 {
    display: none;
  }
  .opcoes button {
    width: fit-content;
    min-width: fit-content;
    padding: 10px;
    margin: 0 5px 0 0;
  }
  .conteudo {
    width: 100%;
    padding: 80px 15px 15px 15px;
  }
  .conteudo .parte {
    padding: 15px;
  }
  .conteudo .parte .tema .imagem span {
    top: 2px;
    left: 5px;
    width: calc(100% - 10px);
    height: 35px;
    border-radius: 15px 15px 0 0;
  }
}
</style>
